import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment'
import HttpClient from "./http-client";
import { MOD_GET_POSTS, MOD_POST_PIN, MOD_POST_STATUS, MOD_POST_DELETE, MOD_AUTO_COMPLETE, MOD_EDIT_POST, MOD_BLOCK_USER, MOD_UPDATE_TAGS, GET_POST_DETAILS, CREATE_UGC_REQUEST, CREATE_UGC_TEMPLATE, REMOVE_UGC_TEMPLATE, GET_UGC_POST_REQUEST_DATA, MOD_REORDER_PIN, UPDATE_INSTA_POST, PaidPlanIds, DONWLOAD_IMAGE, MOD_POST_HIGHLIGHT, UPDATE_POST_CAROSAL } from './api'
import { MOD_DATA, MOD_CHECK, MOD_PST_ST, MOD_PIN, MOD_DETAILS, MOD_TAB, MOD_FLT_BD_DATE, MOD_SRC_TAG, MOD_FLT_LIMIT, MOD_PAGIN, MOD_FLT_LOD, MOD_EP_LOD, MOD_FLT_TAG, MOD_FLT_FEED, MOD_FLT_TYPE, MOD_FLT_TAG_RM, MOD_FLT_FEED_RM, MOD_FLT_TYPE_RM, MOD_ALL_FLT_RM, MOD_SEC_PST, MOD_FLT_DATE, MOD_FLT_DATE_RM, MOD_FLT_TAG_EXTD, MOD_CHECK_DT, MOD_CHECK_DT_RM, MOD_CHECK_DT_ALL, MOD_CHECK_DT_B, MOD_CHECK_DT_BRM, MOD_OFFSET, OPEN_UGC, UGC_DATA, UGC_DATA_RM, UGC_TMP_UP, UGC_TMP_ADD, UGC_TMP_RM, UGC_REQ_DATA, MOD_SV_TAG, MOD_RM_TAG, MOD_PIN_LIST, MOD_PST_REF, DASHBOARD_DATA, GET_RECENT_POST_DATA, MOD_RECOMM_RM, MOD_RECOMM, MOD_SENTI_RM, MOD_LANG, MOD_LANG_RM, MOD_SENTI, MOD_UGC, MOD_UGC_RM, MOD_FLT_RULE_RM, MOD_FLT_RULE, MOD_LOD, MOD_NOTI } from '../reducers/keys'
import store from '../store'
import { TOAST_UPDATE, TOAST_LOADING, TOAST_SUCCESS, TOAST_ERROR, SOCKET_CONNECTION, handleCatchError } from '../utils';
import SweetAlert from '../app/CommonComponents/SweetAlert';
import { toggleAddFeedsSection } from './show_modal_Action';
import { GET_FEEDS } from './manageFeedsAction';
import { getWallFeeds } from './analyticsAction';
import { SHOW_DEMO_POST } from './wallsAction';
import { getWidgetWallData } from './wallDataAction';
const Alert = new SweetAlert();
let ExpiredPostQueue = [];
let wallDataTimer;

export const getModeration = () => {
    const { moderation, wallData } = store.getState();
    const { filter, paginateData } = moderation;
    const feedsData = store.getState().manageFeeds?.feeds || [];
    const wall_id = localStorage.getItem('wallId');
    return (dispatch) => {
        if(!wallData?.wallData) {
            if(!wallDataTimer) wallDataTimer = setTimeout(() => {
                wallDataTimer = null;
                dispatch(getModeration());
            }, 1000)
            return;
        }
        if (!wall_id) return;

        const cloneFilter = {
            ...filter,
            tags: filter.tags.join(),
            feeds: filter.feeds.join(),
            postList: filter.postList.join(),
            postType: filter.postType.join(),
            isCarauselPost: Number(wallData?.wallData?.wall?.Personalization?.carouselPost ?? false),
            language: filter.language.join(),
            recommendation: filter.recommendation.join(),
            sentiment: filter.sentiment.join(),
            offset_start: (paginateData.currentPage - 1) * filter.limit || 0,
            limit: filter.limit,
            tags: filter.tags.join(),
            wallId: wall_id,
            duplicatePost: filter.duplicatePostId,
        }
        dispatch({ type: MOD_LOD, payload: true });
        dispatch({ type: MOD_CHECK_DT_ALL });
        new HttpClient().post(MOD_GET_POSTS, cloneFilter).then(({ data: { responseCode, responseData } }) => {
            if (responseCode === 200) {
                const { privatePostCount, publicPostCount, totalPostCount, upcomingPostCount, posts } = responseData || {};
                dispatch({ type: MOD_DETAILS, payload: { privatepost: privatePostCount, publicpost: publicPostCount, totalpost: totalPostCount, upcomingpost: upcomingPostCount } });
                
                dispatch({ type: MOD_LOD, payload: false });
                if (wallData?.wallData?.wall?.Personalization?.demoWall > 0 && publicPostCount > 0) SHOW_DEMO_POST(0, localStorage.getItem('wallId'));

                dispatch({ type: MOD_DATA, payload: { listData: posts, total: totalPostCount, page: responseData?.page, offset: 0 } });
                dispatch({ type: MOD_FLT_LOD, payload: false });
                if(paginateData.currentPage > responseData?.page && responseData?.page > 0)dispatch(onUpdatePage(responseData?.page))
                if (!totalPostCount) dispatch(toggleAddFeedsSection(true))
            }
        }).catch(handleCatchError);
        if (!(feedsData?.length)) dispatch(GET_FEEDS())
    }
}


export const onNextNavigateClick = () => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        const { filter: { limit }, paginateData: { currentPage = 0, totalPages } = {} } = store.getState().moderation;
        const nextPage = currentPage + 1;
        
        if (nextPage <= totalPages) {
            const offset = limit * (nextPage - 1);
            dispatch({ type: MOD_PAGIN, payload: { currentPage: nextPage, offset }, });
            setTimeout(() => dispatch(getModeration()), 400);
        }

    }
};


export const onPrevNavigateClick = () => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        var { filter, paginateData } = store.getState().moderation;
        let currentPage = paginateData?.currentPage - 1;
        if (currentPage > 0) {
            const offset = filter.limit * (currentPage - 1);
            dispatch({ type: MOD_PAGIN, payload: { currentPage, offset } })
            setTimeout(() => dispatch(getModeration()), 400)
        }
    }
}


export const onUpdatePage = (currentPage) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        var { filter } = store.getState().moderation;
        const offset = filter.limit * (currentPage - 1);
        dispatch({ type: MOD_PAGIN, payload: { currentPage, offset } })
        dispatch({ type: MOD_CHECK_DT_ALL });
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const autoCompleteSearch = (keyword) => (keyword) ? new HttpClient().post(`${MOD_AUTO_COMPLETE}`, { keyword, wallId: localStorage.getItem('wallId') }) : Promise.resolve({ data: { tags: [], status: true } })


export const clickToPostStatus = (index, status) => {
    const { listData } = store.getState().moderation;
    const post = listData?.[index] || {};
    const isCarouselPost = post?.imageList?.length > 1;
    const postId = isCarouselPost ? post.ptPost : post.postId;
    const wallId = localStorage.getItem('wallId');
    if(!post?.id) return;
    return (dispatch) => {
        new HttpClient().post(`${MOD_POST_STATUS}`, { 
            wallId, 
            postId: String(postId), 
            status,
            adminId: localStorage.getItem('Isadmin') || ''
        }).then((response) => {
                const { responseCode, synced } = response.data;
                if (responseCode === 200) {
                    status === 1 ? TOAST_SUCCESS('Post is Public now') : TOAST_ERROR('Post is Private now');
                    if(status === 2){
                        const getHighlight = post?.highlight == 1;
                        if (getHighlight) callSocket('spotlightstatus', { ...post, highlight: 0, wallId }); 
                    }
                    callSocket('poststatus', [wallId, synced]);
                    setTimeout(() => dispatch(getModeration()), 100)
                }
            }).catch(handleCatchError);
    }
}


export const clickToPostStatusALL = (status) => {
    return (dispatch) => {
        Alert.alertFire({
            title: 'Are you sure?',
            text: `You want to ${status === 1 ? '' : 'dis'}approve selected post?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5354fc",
            confirmButtonText: "Continue"
        }).then((result) => {
            if (!result.value) return;

            const { check_uncheck_all } = store.getState().moderation;
            const postIds = check_uncheck_all?.data?.map(item => {
                return item.imageList?.length ? item.ptPost : item.postId
            }) || [];
            const wallId = localStorage.getItem('wallId');

            new HttpClient().post(MOD_POST_STATUS, {
                wallId,
                postId: postIds.join(),
                status,
                adminId: localStorage.getItem('Isadmin') || ''
            }).then(({ data: { responseCode, responseMessage , synced} }) => {
                    if (responseCode === 200) {
                        dispatch({ type: MOD_CHECK_DT_ALL });
                        TOAST_SUCCESS(`Selected posts are ${status === 1 ? 'public' : 'private'} now.`);
                        setTimeout(() => dispatch(getModeration()), 400);
                        callSocket('poststatus', [wallId, synced]);
                    } else {
                        TOAST_ERROR(responseMessage);
                    }
                }).catch(handleCatchError);
        });
    };
};


export const clickToPostDeleteALL = (navigate) => {
    return (dispatch) => {
        Alert.alertFire({
            title: 'Are you sure?',
            text: 'You want to delete selected post?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5354fc",
            confirmButtonText: "Continue"
        }).then((result) => {
            if (!result.value) return;

            const { listData, check_uncheck_all } = store.getState()?.moderation;
            const postId = check_uncheck_all?.data?.map(item => item.imageList?.length ? item.ptPost : item.postId) || [];
            new HttpClient().post(MOD_POST_DELETE, { wallId: localStorage.getItem('wallId'), postId: postId.join(), adminId: localStorage.getItem('Isadmin') || '' })
                .then(({ data: { responseCode, responseMessage, synced } }) => {
                    if (responseCode === 200) {
                        TOAST_ERROR('Selected posts are deleted now');
                        dispatch({ type: MOD_PST_ST, payload: listData });
                        dispatch(getWallFeeds(localStorage.getItem('ownerId')));
                        setTimeout(() => dispatch(getModeration()), 400);
                        const getHighlight = listData.find(item => item.highlight === 1 && postId.includes(item.postId));
                        if (getHighlight) callSocket('spotlightstatus', { ...getHighlight, highlight: 0,wallId: localStorage.getItem('wallId')}); 
                        callSocket('poststatus', [localStorage.getItem('wallId'), synced]);
                    } else {
                        TOAST_ERROR(responseMessage);
                    }
                }).catch(handleCatchError);
        });
    };
};


export const limitUpdate = (limit) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_FLT_LIMIT, payload: limit })
        setTimeout(() => dispatch(getModeration()), 400)
    }
}


export const activeTabActionFilter = (activeTab) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_TAB, payload: activeTab })
        dispatch(onUpdatePage(1))
    }
}

export const dateRangeFilter = (startDate, endDate) => {
    return (dispatch) => {
        var { filter } = store.getState().moderation;
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_OFFSET, payload: 0 });
        dispatch({ type: MOD_FLT_DATE, payload: { startDate: moment(startDate).format("MMMM DD, YYYY"), endDate: moment(endDate).format("MMMM DD, YYYY") } });
        dispatch({ type: MOD_FLT_BD_DATE, payload: { startDate, endDate } })
        dispatch({ type: MOD_PAGIN, payload: {} })
        setTimeout(() => dispatch(getModeration()), 100)
        if (filter.offset_start && filter.offset_start > 0) setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const searchTagsFilter = (searchTags) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_FLT_TAG_EXTD, payload: searchTags });
        dispatch({ type: MOD_SRC_TAG, payload: searchTags })
        dispatch({ type: MOD_PAGIN, payload: {} })
        dispatch({ type: MOD_OFFSET, payload: 0 })
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const searchPostFilter = (searchPost) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_SEC_PST, payload: searchPost })
        dispatch({ type: MOD_OFFSET, payload: 0 })
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const clickToRefresh = () => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const postCarosal = (status) => {
    const { dashboardData } = store.getState()
    dashboardData.dashboarddata.allWalls = dashboardData.dashboarddata.allWalls && dashboardData.dashboarddata.allWalls.map((item) => {
        if (item.id == localStorage.getItem('wallId')) return { ...item, carouselPost: status }
        else return { ...item }
    })

    return (dispatch) => {
        dispatch({ type: DASHBOARD_DATA, payload: dashboardData.dashboarddata, });
        dispatch({ type: MOD_FLT_LOD, payload: true });
        setTimeout(() => dispatch(getModeration(status)), 400)
    }
}

export const updateCheckAll = (isCheckAll) => {
    const { listData } = store.getState().moderation
    return (dispatch) => {
        const updateData = listData?.map(item => ({ ...item, isChecked: isCheckAll })) || [];
        dispatch({ type: MOD_CHECK_DT_ALL });
        dispatch({ type: MOD_CHECK, payload: { listData: updateData, isCheckedPostCount: isCheckAll ? updateData.length : 0 } });
    }
}

export const updateCheckStatusAll = (status) => {
    const { listData } = store.getState().moderation
    return (dispatch) => {
        if (status) {
            const updateData = listData?.map(item => ({ ...item, isChecked: false })) || [];
            dispatch({ type: MOD_CHECK_DT_BRM, payload: { status: false, data: updateData } })
            dispatch({ type: MOD_CHECK, payload: { listData: updateData, isCheckedPostCount: 0 } });
        }
        else {
            const updateData = listData?.map(item => ({ ...item, isChecked: true })) || [];
            dispatch({ type: MOD_CHECK_DT_B, payload: { status: true, data: updateData } })
            dispatch({ type: MOD_CHECK, payload: { listData: updateData, isCheckedPostCount: 0 } });

        }
    }
}

export const removeCheckAll = () => {
    const { listData } = store.getState().moderation
    return (dispatch) => {
        const updateData = listData?.map(item => ({ ...item, isChecked: false })) || [];
        dispatch({ type: MOD_CHECK_DT_ALL });
        dispatch({ type: MOD_CHECK, payload: { listData: updateData, isCheckedPostCount: false ? updateData.length : 0 } });
    }
}

export const selectPostUpdate = (index, callBack) => {
    return (dispatch) => {
        const { listData, isCheckedPostCount } = store.getState().moderation;

        if (listData?.[index]) {
            listData[index].isChecked = !listData[index].isChecked;
            const checkedCount = listData.filter(item => item.isChecked).length;
            const status = checkedCount === listData.length;
            const actionType = listData[index].isChecked ? MOD_CHECK_DT : MOD_CHECK_DT_RM;
            dispatch({ type: actionType, payload: { status, data: listData[index] } });
            dispatch({ type: MOD_CHECK, payload: { listData, isCheckedPostCount } });
            setTimeout(() => callBack?.(), 100);
        }
    }
};


export const clickToPostPin = (index, postId, status) => {
    return (dispatch) => {
        const { listData } = store.getState().moderation;
        new HttpClient().post(`${MOD_POST_PIN}`, { wallId: localStorage.getItem('wallId'), postId: String(postId), status: status ? 0 : 1, adminId: localStorage.getItem('Isadmin') || '' })
            .then(({ data: { responseCode, responseData } }) => {
                if (responseCode === 200) {
                    const updateData = listData.map((item, iIndex) =>
                        iIndex === index ? { ...item, pin: status ? 0 : responseData?.indexing } : item
                    );
                    updateData.sort((a, b) => b.createdAt - a.createdAt);
                    updateData.sort((a, b) => {
                        if (a.pin === b.pin) return 0;
                        if (a.pin === 1 || b.pin === 0) return -1;
                        return 1;
                    });
                    updateData.sort((a, b) => b.highlight - a.highlight);
                    dispatch({ type: MOD_PIN, payload: updateData });
                    status ? TOAST_ERROR('Post Removed from top') : TOAST_SUCCESS('Post is pinned to top');
                }
            }).catch(handleCatchError);
    };
};


export const clickToDeletePost = (item, index, navigate) => {
    return (dispatch) => {
        Alert.alertFire({
            title: "Are you sure?",
            text: "You will not be able to recover this post.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5354fc",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: false
        }).then((result) => {
            if (!result.value) return;

            const { listData } = store.getState().moderation;

            new HttpClient().post(MOD_POST_DELETE, { postId: item.imageList?.length ? item.ptPost : item.postId, wallId: localStorage.getItem('wallId'), adminId: localStorage.getItem('Isadmin') || '' })
                .then(({ data: { responseCode, responseMessage , synced} }) => {
                    if (responseCode === 200) {
                        if (listData?.length > 0 && listData[index]) {
                            const deletedPost = listData[index];
                            deletedPost.isChecked = false;
                            const checkedItems = listData.filter(item => item.isChecked);
                            const allChecked = checkedItems.length === listData.length;
                            dispatch({ type: MOD_CHECK_DT_RM, payload: { status: allChecked, data: deletedPost } });
                            dispatch(getWallFeeds(localStorage.getItem('ownerId')));
                            listData.splice(index, 1);
                            dispatch({ type: MOD_PIN, payload: listData });
                            callSocket('poststatus', [localStorage.getItem('wallId'), synced]);
                        const getHighlight = listData.find(item => item.highlight === 1 && item.postId == item.imageList?.length ? item.ptPost : item.postId);
                        if (getHighlight) callSocket('spotlightstatus', { ...getHighlight, highlight: 0,wallId: localStorage.getItem('wallId')}); 
                        }

                        TOAST_SUCCESS('Your post has been deleted.');
                        dispatch(getModeration());
                    } else {
                        TOAST_ERROR(responseMessage);
                    }
                }) .catch(handleCatchError);
        });
    };
};

export const removeRuleFilter = (value, status) => {
    return (dispatch) => {
        const { filterBody, filter } = store.getState().moderation;
        if (filterBody?.rules?.length > 0 || filter?.postList?.length > 0) {
            const findIndex = filterBody?.rules?.findIndex(x => x == value)
            dispatch({ type: MOD_FLT_LOD, payload: true });
            if (findIndex !== -1 && status) { dispatch({ type: MOD_FLT_RULE_RM, payload: findIndex });}
            if (filter?.postList?.length > 0 && !status) { dispatch({ type: MOD_NOTI, payload: [] });}
            setTimeout(() => dispatch(getModeration()), 400)
        }
    }
}


export const updateRuleFilter = (data) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_RULE, payload: data });
    }
}

export const updateFilterUgc = (data) => {
    return (dispatch) => {
        var { filter } = store.getState().moderation;
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_UGC, payload: data });
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const removeFilterUgc = (data) => {
    return (dispatch) => {
        const { filterBody } = store.getState().moderation;
        if (Object.keys(filterBody).length > 0 && filterBody.ugc.length > 0) {
            const findIndex = filterBody.ugc.findIndex(x => x.key == data.key)
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_UGC_RM, payload: { findIndex, value: data.key } });
            setTimeout(() => dispatch(getModeration()), 400)
        }
    }
}

export const clickToBlockUser = (index, username) => {
    return (dispatch) => {
        Alert.alertFire({
            title: "Confirm User",
            html: `<span>${username}'s Post</span>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5354fc",
            confirmButtonText: "Continue",
            closeOnConfirm: true
        }).then((result) => {
            if (!result.value) return;

            new HttpClient().post(MOD_BLOCK_USER, { wallId: localStorage.getItem('wallId'), username })
                .then(({ data: { responseCode, responseMessage } }) => {
                    if (responseCode === 200) {
                        dispatch(getModeration());
                        TOAST_SUCCESS(responseMessage);
                    } else { TOAST_ERROR(responseMessage); }
                }).catch(handleCatchError);
        })
    };
};

export const onUpdateTags = (data, isTaggModal, calback) => {
    return (dispatch) => {
        new HttpClient().post(MOD_UPDATE_TAGS, data)
            .then(({ data: { responseCode, responseData, responseMessage } }) => {
                if (responseCode === 200) {
                    setTimeout(() => dispatch(getModeration()), 100)
                    if (isTaggModal) TOAST_SUCCESS(responseMessage);
                }
                calback()
            }).catch(handleCatchError);
    }
}


export const updateFilterPostTags = (data) => {
    return (dispatch) => {
        var { filter } = store.getState().moderation;
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_FLT_TAG, payload: data });
        dispatch({ type: MOD_PAGIN, payload: {} })
        setTimeout(() => dispatch(getModeration()), 100)
        if (filter.offset_start && filter.offset_start > 0) setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const updateFilterSocialFeeds = (data) => {
    return (dispatch) => {
        var { filter } = store.getState().moderation;
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_FLT_FEED, payload: data });
        dispatch({ type: MOD_PAGIN, payload: {} })
        setTimeout(() => dispatch(getModeration()), 100)
        if (filter.offset_start && filter.offset_start > 0) setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const removeFilterSocialFeeds = (data) => {
    return (dispatch) => {
        const { filterBody } = store.getState().moderation;
        if (Object.keys(filterBody).length > 0 && filterBody.socialFeed.length > 0) {
            const findIndex = filterBody.socialFeed.findIndex(x => x.value == data.value)
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_FLT_FEED_RM, payload: { findIndex, value: data.value } });
            setTimeout(() => dispatch(getModeration()), 100)
        }
    }
}

export const updateFilterPostType = (data) => {
    return (dispatch) => {
        var { filter } = store.getState().moderation;
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_FLT_TYPE, payload: data });
        dispatch({ type: MOD_PAGIN, payload: {} })
        setTimeout(() => dispatch(getModeration()), 100)
        if (filter.offset_start && filter.offset_start > 0) setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const removeFilterPostType = (value) => {
    return (dispatch) => {
        const { filterBody } = store.getState().moderation;
        if (Object.keys(filterBody).length > 0 && filterBody.postType.length > 0) {
            const findIndex = filterBody.postType.findIndex(x => x == value)
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_FLT_TYPE_RM, payload: { findIndex, value } });
            setTimeout(() => dispatch(getModeration()), 100)
        }
    }
}


export const removeFilterPostTags = (value, isText) => {
    return (dispatch) => {
        const { filterBody, filter } = store.getState().moderation;
        if ((Object.keys(filterBody).length > 0 && filterBody.postTags.length > 0) || filter?.text?.length > 0) {
            const findIndex = filterBody.postTags.findIndex(x => x == value)
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_FLT_TAG_RM, payload: { findIndex, value, isText } });
            let textInput = document.getElementById('searchPost')
            if (textInput) textInput.value = ""
            setTimeout(() => dispatch(getModeration()), 100)
        }
    }
}


export const filterDataAnalytics = (value) => {
    return (dispatch) => {
        var { filter } = store.getState().moderation;

        var { data, filter} = value[0];

        if(data){

        const getFilterdata = data.split("/");

        dispatch({ type: MOD_FLT_LOD, payload: true });

        if(filter=="network"){
            dispatch({ type: MOD_FLT_FEED, payload: getFilterdata[0] });
        }

        if(filter=="tags"){
            dispatch({ type: MOD_FLT_TAG_EXTD, payload: getFilterdata[0] });
            dispatch({ type: MOD_SRC_TAG, payload: getFilterdata[0] })
            dispatch({ type: MOD_OFFSET, payload: 0 })
        }

        if(filter=="media"){
            dispatch({ type: MOD_FLT_TYPE, payload: getFilterdata[0]=='With Image' ? '2,4' : getFilterdata[0]=='With Video' ?  '3,5' : '1' });
        }

        if(filter=="recommendation"){
            dispatch({ type: MOD_RECOMM, payload: getFilterdata[0]=='Recommended' ? 1 : getFilterdata[0]=='Considerable' ?  2 : 3 });
        }

        if(filter=="language"){
            dispatch({ type: MOD_LANG, payload: getFilterdata[0] });
        }

    if(filter=="sentiments"){
            dispatch({ type: MOD_SENTI, payload: getFilterdata[0] });
        }

        if(getFilterdata && getFilterdata.length && getFilterdata[1]){            
            const startDate = getFilterdata[1];
            const endDate = getFilterdata[2];

            dispatch({ type: MOD_FLT_DATE, payload: { startDate: moment(startDate).format("MMMM DD, YYYY"), endDate: moment(endDate).format("MMMM DD, YYYY") } });
            dispatch({ type: MOD_FLT_BD_DATE, payload: { startDate, endDate } })
        }
      
        setTimeout(() => dispatch(getModeration()), 100)
     }
  } 
}


export const removeAllFilterBody = (status) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_ALL_FLT_RM });
        dispatch({ type: MOD_TAB, payload: 0 })
        let textInput = document.getElementById('searchPost')
        if (textInput) textInput.value = ""
        let textInput1 = document.getElementById('searchTag');
        if (textInput1) textInput1.value = "";
        if (!status) setTimeout(() => dispatch(getModeration()), 100)
    }
}

export const removeDateRanges = () => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_FLT_DATE_RM });
        setTimeout(() => dispatch(getModeration()), 100)
    }
}



export const removeFilterRecommendation = (value) => {
    return (dispatch) => {
        const { filterBody } = store.getState().moderation;
        if (Object.keys(filterBody).length > 0 && filterBody.recommendation.length > 0) {
            const findIndex = filterBody.recommendation.findIndex(x => x == value);
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_RECOMM_RM, payload: { findIndex, value } });
            setTimeout(() => dispatch(getModeration()), 400)
        }
    }
}

export const updateFilterRecommendation = (value) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_RECOMM, payload: value });
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const removeFilterSentiment = (value) => {
    return (dispatch) => {
        const { filterBody } = store.getState().moderation;
        if (Object.keys(filterBody).length > 0 && filterBody.sentiment.length > 0) {
            const findIndex = filterBody.sentiment.findIndex(x => x == value);
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_SENTI_RM, payload: { findIndex, value } });
            setTimeout(() => dispatch(getModeration()), 400)
        }
    }
}

export const updateFilterLanguage = (value) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_LANG, payload: value });
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const removeFilterLanguage = (value) => {
    return (dispatch) => {
        const { filterBody } = store.getState().moderation;
        if (Object.keys(filterBody).length > 0 && filterBody.language.length > 0) {
            const findIndex = filterBody.language.findIndex(x => x == value);
            dispatch({ type: MOD_FLT_LOD, payload: true });
            dispatch({ type: MOD_LANG_RM, payload: { findIndex, value } });
            setTimeout(() => dispatch(getModeration()), 400)
        }
    }
}

export const updateFilterSentiment = (value) => {
    return (dispatch) => {
        dispatch({ type: MOD_FLT_LOD, payload: true });
        dispatch({ type: MOD_SENTI, payload: value });
        setTimeout(() => dispatch(getModeration()), 400)
    }
}

export const ugcModal = (state) => {
    return (dispatch) => { dispatch({ type: OPEN_UGC, payload: state }) }
}


export const GET_UGC_POST_DETAIL = (data) => {
    return (dispatch) => {
        new HttpClient().post(GET_POST_DETAILS, { id: data.id, wallId: localStorage.getItem('wallId') })
            .then(({ data: { responseCode, responseData, responseMessage } }) => {
                if (responseCode === 200) {
                    dispatch({ type: UGC_DATA, payload: responseData })
                }
            })
    }
}

export const CLEAR_UGC_DATA = () => dispatch => dispatch({ type: UGC_DATA, payload: {} });

export const CLEAR_UGC_REQUEST = () => dispatch => dispatch({ type: UGC_DATA_RM, payload: [] })

export const SEND_UGC = (data, callBack) => {
    new HttpClient().post(CREATE_UGC_REQUEST, data).then(({ data: { responseCode, responseMessage } }) => {
        if (responseCode === 200) { callBack() }
        else TOAST_ERROR(data.message)
        callBack()
    }).catch(handleCatchError);
}

export const ADD_UGC_TEMPLATE = (obj, callBack) => {
    return (dispatch) => {
        new HttpClient().post(CREATE_UGC_TEMPLATE, obj).then(({ data: { responseCode, responseData, responseMessage } }) => {
            if (responseCode === 200) {
                if (obj.id) { dispatch({ type: UGC_TMP_UP, payload: responseData }); callBack(obj.id) }
                else { dispatch({ type: UGC_TMP_ADD, payload: responseData }); callBack(responseData?.id) }
            }
        }).catch(handleCatchError)
    }
}

export const DELETE_UGC_TEMPLATE = (obj, callback) => {
    return (dispatch) => {
        new HttpClient().post(REMOVE_UGC_TEMPLATE, obj).then(({ data: { responseCode, responseData, responseMessage } }) => {
            if (responseCode === 200) {
                callback()
                TOAST_SUCCESS(responseMessage)
                dispatch({ type: UGC_TMP_RM, payload: obj.id })
            }
        }).catch(handleCatchError)
    }
}

export const GET_UGC_REQUEST = (data) => {
    return (dispatch) => {
        new HttpClient().post(GET_UGC_POST_REQUEST_DATA, { id: data.id, wallId: localStorage.getItem('wallId') })
            .then(({ data: { responseCode, responseData, responseMessage } }) => {
                if (responseCode === 200 && responseData && responseData[0]) {
                    dispatch({ type: UGC_REQ_DATA, payload: responseData[0] })
                }
            }).catch(handleCatchError)
    }
}

export const autoCompleteTag = (keyword) => {
    var formData = new FormData();
    formData.append("keyword", keyword)
    formData.append("type", 1)
    formData.append("slectedTags", '')
    formData.append("publishAction", 1)
    formData.append("wallId", localStorage.getItem('wallId'))
    return new HttpClient().post(`${MOD_AUTO_COMPLETE}`, formData);
}

export const ADD_SELECTED_TAGS = (tag) => (dispatch => { dispatch({ type: MOD_SV_TAG, payload: tag }) })
export const REMOVE_SELECTED_TAGS = (tag) => (dispatch => { dispatch({ type: MOD_RM_TAG, payload: tag }) })
export const GET_INSTAGRAM_IMAGE = (instagramUrl) => axios.get(instagramUrl)

export const GET_PIN_TO_TOP_LIST = () => {
    return (dispatch => {
        new HttpClient().post(MOD_GET_POSTS, { wallId: localStorage.getItem('wallId'), pinned: 1 })
            .then(({ data: { responseCode, responseData, responseMessage } }) => {
                if (responseCode === 200) {
                    dispatch({ type: MOD_PIN_LIST, payload: responseData?.posts })
                }
            }).catch(handleCatchError);
    })
};

export const GET_REORDER_PIN_TO_TOP = (postId, indexing, callBack=() => {}) => {
    return (dispatch => {
        new HttpClient().post(MOD_REORDER_PIN, { "wallId": localStorage.getItem('wallId'), "postId": postId, "indexing": indexing })
            .then(({ data: { responseCode, responseData, responseMessage } }) => {
                if (responseCode === 200) {
                    dispatch(getModeration(false))
                    TOAST_SUCCESS('Post Pin Order change Sucessfully')
                    callBack(true);
                }
            }).catch(handleCatchError);
    })
}


export const editpost = (updateData, callback) => {
    return (dispatch) => {
        dispatch({ type: MOD_EP_LOD, payload: true })

        new HttpClient().post(MOD_EDIT_POST, updateData)
            .then(({ data: { responseCode, responseData, responseMessage } }) => {
                if (responseCode === 200) {
                    dispatch(getModeration())
                    TOAST_SUCCESS(responseMessage)
                    dispatch({ type: MOD_EP_LOD, payload: false })
                }
                callback()
            }).catch(handleCatchError);
    }
}


//* ------------refresh instagram post-------------


export const INSTA_AGENT_UPDATE = (payload) => { return new HttpClient().post(UPDATE_INSTA_POST, payload) }


export const ExpiredPostInstaQueue = (item) => {
    const { userData } = store.getState().authenticated;
    if (!ExpiredPostQueue.includes(item) && userData && PaidPlanIds.includes(userData?.UserPlan?.planId) && userData?.user?.is_trial == 0) {
        ExpiredPostQueue.push(item)
    }
    if (ExpiredPostQueue.length == 1) processImageInQueue()
}

const processImageInQueue = async () => {
    try {
        const { dispatch } = store
        const { userData } = store.getState().authenticated;
        if (ExpiredPostQueue?.length > 0 && Object.keys(ExpiredPostQueue[0]).length > 0) {
            const item = ExpiredPostQueue[0]
            const { feedId, spostId, link, postParent, parentLink, status } = item
            const type = link?.includes("reel") ? 3 : 2
            const refreshPostId = document.querySelector(`.refresh_post_media_${item.id}`);
            refreshPostId?.setAttribute('style', 'display:none !important')
            const payload = { feedId, postId: spostId, postParent: postParent, wallId: localStorage.getItem("wallId"), link: parentLink ? parentLink : link, db_table: userData?.UserPlan?.db_table, owner: localStorage.getItem('ownerId') }
            if (status == 1) {
                INSTA_AGENT_UPDATE({ ...payload }).then((res) => {
                    const { response_code, responseData } = res.data
                    if (response_code == 200 && responseData?.length) {
                        dispatch(UPDATE_LISTDATA_BY_ID(responseData, type))
                        ExpiredPostQueue.shift();
                        processImageInQueue()
                    }
                    else {
                        ExpiredPostQueue.shift();
                        processImageInQueue()
                        refreshPostId?.setAttribute('style', 'display:block !important')
                    }
                }).catch(error => {
                    const { resposne_message } = error.response.data
                    ExpiredPostQueue.shift();
                    processImageInQueue()
                    refreshPostId?.setAttribute('style', 'display:block !important')
                })
            }
            else {
                ExpiredPostQueue.shift();
                processImageInQueue()
                refreshPostId?.setAttribute('style', 'display:block !important')
            }
        }
    }
    catch (error) {
        console.log("error", error)
    }
}


export const UPDATE_INSTA_POST_ACTION = (item) => (dispatch) => {
    const { userData } = store.getState().authenticated;
    const { feedId, postId, link, postParent, parentLink } = item
    const type = link && link.includes("reel") ? 3 : 2
    const refreshPostId = document.querySelector(`.refresh_post_media_${item.id}`);
    const refreshIcon = document.querySelector(`.refresh-icon-${item.id}`);
    refreshIcon?.setAttribute('style', 'animation:animation-spinner 1.5s linear infinite');
    refreshPostId?.setAttribute('style', 'pointer-events:none');
    const toastId = TOAST_LOADING()
    const payload = { feedId, postId: postId, postParent: postParent, wallId: localStorage.getItem("wallId"), link: parentLink ? parentLink : link, db_table: userData?.UserPlan?.db_table, owner: localStorage.getItem('ownerId') }
    INSTA_AGENT_UPDATE({ ...payload }).then((res) => {
        const { response_code, responseData } = res.data
        if (response_code == 200 && responseData && responseData.length) {
            dispatch(UPDATE_LISTDATA_BY_ID(responseData, type))
            TOAST_UPDATE(toastId, "success", "Post Updated Successfully")
            refreshPostId?.setAttribute('style', 'display:none');
            refreshIcon?.setAttribute('style', 'animation:none');
        }
        else {
            TOAST_UPDATE(toastId, "error", "Error finding Post!")
            refreshPostId?.setAttribute('style', 'display:block');
            refreshIcon?.setAttribute('style', 'animation:none');
        }
    }).catch(error => {
        const { resposne_message } = error.response.data
        TOAST_UPDATE(toastId, "error", resposne_message || "Something went wrong!")
        refreshPostId?.setAttribute('style', 'display:block');
        refreshIcon?.setAttribute('style', 'animation:none');
    })
}


export const UPDATE_LISTDATA_BY_ID = (payload, type) => (dispatch) => dispatch({ type: MOD_PST_REF, payload, postType: type })

export const ugcImageDownload = () => {
    const { details } = store.getState().moderation;
    return new HttpClient().get(`${DONWLOAD_IMAGE}/${details.wallId}`)
}





export const clickToPostHighlight = (index, postId, id, highlight, isPopup, callback) => {
    return (dispatch) => {
        callback();
        const { listData } = store.getState().moderation;
        const wallId = localStorage.getItem('wallId');

        const updateHighlightStatus = (data, targetId) => {
            const updatedItem = data.find(item => item.id === targetId);
            if (updatedItem) {
                updatedItem.wallId = parseInt(wallId);
                updatedItem.highlight = updatedItem.highlight;
                callSocket('spotlightstatus', { ...updatedItem });
            }
        };

        const sortAndDispatch = (data, skipSort = false) => {
            if (!skipSort) {
                data.sort((a, b) => b.createdAt - a.createdAt);
                data.sort((a, b) => {
                    if (a.pin === b.pin) return 0;
                    if (a.pin === 1 || b.pin === 0) return -1;
                    return 1;
                });
                data.sort((a, b) => b.highlight - a.highlight);
            }
            dispatch({ type: MOD_PIN, payload: data });
        };

        if (id) {
            new HttpClient().post(MOD_POST_HIGHLIGHT, { wallId, postId:String(postId), status: highlight ? 0 : 1, adminId: localStorage.getItem('Isadmin') || '' }).then(({ data: { responseCode, responseData, synced } }) => {
                if (responseCode === 200) {
                    const updateData = listData.map((item, iIndex) => ({ ...item, highlight: iIndex === index ? (highlight ? 0 : 1) : 0 }));
                    updateHighlightStatus(updateData, id);
                    sortAndDispatch(updateData, isPopup);

                    if (!highlight) callback();
                    toast[highlight ? 'error' : 'success'](highlight ? 'Post removed from Spotlight' : 'Post Successfully Spotlighted');
                    setTimeout(() => { window._mfq?.push(['activateFeedback', 'jojSb-ie7k-CEfyyzbgw2w']); }, 30000);
                }
            }).catch(handleCatchError);
        } else if (index) {
            const getHighlight = listData.find(item => item.id === index && item.highlight === 1);
            if (getHighlight) updateHighlightStatus([{ ...getHighlight, highlight: 0 }], index);
            sortAndDispatch(listData);
        }
    };
};


export const postStatusDashboard = (index, item, status) => {
    const { recent_post_data } = store.getState().dashboardDisplayReducer;
    return (dispatch) => {
        if (item?.wallId) {
            new HttpClient().post(`${MOD_POST_STATUS}`, { wallId: String(item?.wallId), postId: String(item?.postId), status, adminId: localStorage.getItem('Isadmin') || ''}).then(({ data: { responseCode, synced} }) => {
                if (responseCode === 200) {
                    const updateData = recent_post_data.recentPosts && recent_post_data.recentPosts.map((item, iIndex) => {
                        if (iIndex == index) return { ...item, postStatus: status }
                        else return { ...item }
                    })

                    dispatch({ type: GET_RECENT_POST_DATA, payload: { "recentPosts": updateData } });
                    callSocket('poststatus', [item?.wallId, synced]);

                    if (status == 1) TOAST_SUCCESS('Post is Public now');
                    else TOAST_ERROR('Post is Private now');
                }
            }).catch(handleCatchError);
        }
    }
}

const callSocket = (key, value) => {
    if (value) SOCKET_CONNECTION.emit(key, value);
};

export const updatepostCarosal = (isChecked, p_id) => {
    return (dispatch) => {
        const wallId = localStorage.getItem('wallId');
        new HttpClient().post(UPDATE_POST_CAROSAL, {
            p_id,
            carouselPost: isChecked ? 1 : 0,
            adminId: localStorage.getItem('Isadmin') || '',
            wallId: String(wallId)
        }).then(async ({ data: { synced: sync } }) => {
            if (sync) {
                dispatch({ type: MOD_FLT_LOD, payload: true });
                dispatch(getWidgetWallData(null, wallId, () => dispatch(getModeration())));
                callSocket('wallsuperrefresh', { wallId, sync });
            }
        }).catch(handleCatchError);
    }
}